import { Row } from '@met/react-components';
import styled from 'styled-components';

export const AddAnotherRow = styled(Row)`
  margin-top: 2rem !important;
`;
